import React from 'react';
import styles from './HowItWorksAssets.module.scss';
import urlJoin from 'url-join';
import {CDN_IMAGE_URL} from 'configs';

function HowItWorksAssets() {
  return (
    <div className={styles['assets-section']}>
      <video
        src={urlJoin(
          CDN_IMAGE_URL,
          'p/landing/animations/certificate-verification.mp4 '
        )}
        autoPlay
        muted
        playsInline
        loop
        loading="lazy"
      />
    </div>
  );
}

export default HowItWorksAssets;
